export function t(key: string): string {
  const translations: { [key: string]: string } = {
    'Failed to fetch top picks': 'Failed to fetch top picks',
    'Failed to fetch this application': 'Failed to fetch this application',
    'Try again': 'Try again',
  };
  return translations[key] || key;
}
